import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  ApplicationType,
  ApplicationTypeCreateRequest,
  ApplicationTypeCreateResponse,
  ApplicationTypeDetails,
  ApplicationTypeUpdateRequest,
  ApplicationTypeUpdateResponse,
  LegalEntity
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";

@Injectable({
  providedIn: 'root'
})
export class ApplicationTypeService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/application-types/';
  }

  public getApplicationTypes(): Observable<ApplicationType[]> {
    const url = this.endpoint;
    return this.httpClient.get<ApplicationType[]>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<LegalEntity> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<LegalEntity>(url, request);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + 'columns';
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: UpsertUserColumnRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getApplicationTypeById(id: number): Observable<ApplicationType> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<ApplicationType>(url);
  }

  public deleteApplicationType(id: number): Observable<void> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<void>(url);
  }

  public createApplicationType(requestBody: ApplicationTypeCreateRequest): Observable<ApplicationTypeCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<ApplicationTypeCreateResponse>(url, requestBody);
  }

  public updateApplicationType(id: number, requestBody: ApplicationTypeUpdateRequest): Observable<ApplicationTypeUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<ApplicationTypeUpdateResponse>(url, requestBody);
  }

  public getApplicationTypeDetail(id: number): Observable<ApplicationTypeDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<ApplicationTypeDetails>(url, {});
  }

  getEndPointV1(): string {
    return this.endpoint;
  }

}
